{
  "helpMessage": "<p>यदि आपको कोई समस्या हो रही है, तो कृपया <a><strong>{{phone}}</strong></a> पर कॉल करें (फिर <strong>विकल्प 2</strong> दबाएं)।</p>",
  "noCode": "कोड नहीं मिला?",
  "remainingTime": "{{time}} शेष",
  "sendCode": "नया कोड भेजें",
  "text": "<p>हमने आपके मोबाइल नंबर <strong><PhonePlaceholder /></strong> पर एक 4-अंकीय कोड भेजा है।</p>\n<p>यह कोड {{validityMinutes}} मिनट तक मान्य है।</p>\n<p>जारी रखने के लिए कृपया नीचे कोड दर्ज करें।</p>",
  "title": "अपना कोड दर्ज करें"
}
